module.exports = __webpack_public_path__ + "media/images/favicons/tastee-society/favicon-16x16-69bc0a8006dc52a0e48a0b04833875b0.png";